import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    estatusSolicitudesAC: [],
}

const GET_SOLICITUDES_AC_DIRECCION = 'GET_SOLICITUDES_AC_DIRECCION'
//MÉTODOS 
export const obtenerSolicitudesACDireccion = createAsyncThunk(
    GET_SOLICITUDES_AC_DIRECCION,
    async (estatus) => {
        try {
            const fullUrl = host + `ConsultaPanelesDireccion/obtenerSolicitudesEstatusAC/${estatus}`
            const res = await axios.get(fullUrl)
            let fc_01_solicitudderegistro = []
            let fc_05_solicitudusomarcaeimagen = []
            let fc_06_registrodemaguey = []
            let fc_08_solicitudrenvacioncertificados = []
            let fc_09_solicitudemicioncertificadonomexportacionyentregahologram = []
            let fc_30_notificaciontrasladodeproducto = []
            let fc_31_solicitudseguimiento = []
            let fc_33_solicitudenvasadonacional = []
            let fc_34_notificacionsuspencionyreactivacion = []
            let fc_35_notificaciondeserviciosvarios = []
            let fc_36_solicituddeactualizacion = []
            let fc_40_solicituddeadquisiciondehologramas = []
            let fc_41_solicitudparabebidasconmezcal = []
            if (res.data.data.fc_01_solicitudderegistro) {
                for (let datos of res.data.data.fc_01_solicitudderegistro) {
                    for (let i in datos) {
                        fc_01_solicitudderegistro.push(datos[i])
                    }
                }
            }
            if (res.data.data.fc_09_solicitudemicioncertificadonomexportacionyentregahologram) {
                for (let datos of res.data.data.fc_09_solicitudemicioncertificadonomexportacionyentregahologram) {
                    for (let i in datos) {
                        fc_09_solicitudemicioncertificadonomexportacionyentregahologram.push(datos[i])
                    }
                }
            }
            if (res.data.data.fc_33_solicitudenvasadonacional) {
                for (let datos of res.data.data.fc_33_solicitudenvasadonacional) {
                    for (let i in datos) {
                        fc_33_solicitudenvasadonacional.push(datos[i])
                    }
                }
            }
            if (res.data.data.fc_30_notificaciontrasladodeproducto) {
                for (let datos of res.data.data.fc_30_notificaciontrasladodeproducto) {
                    for (let i in datos) {
                        fc_30_notificaciontrasladodeproducto.push(datos[i])
                    }
                }
            }
            if (res.data.data.fc_05_solicitudusomarcaeimagen) {
                for (let datos of res.data.data.fc_05_solicitudusomarcaeimagen) {
                    for (let i in datos) {
                        fc_05_solicitudusomarcaeimagen.push(datos[i])
                    }
                }
            }
            if (res.data.data.fc_35_notificaciondeserviciosvarios) {
                for (let datos of res.data.data.fc_35_notificaciondeserviciosvarios) {
                    for (let i in datos) {
                        fc_35_notificaciondeserviciosvarios.push(datos[i])
                    }
                }
            }
            if (res.data.data.fc_06_registrodemaguey) {
                for (let datos of res.data.data.fc_06_registrodemaguey) {
                    for (let i in datos) {
                        fc_06_registrodemaguey.push(datos[i])
                    }
                }
            }
            if (res.data.data.fc_08_solicitudrenvacioncertificados) {
                for (let datos of res.data.data.fc_08_solicitudrenvacioncertificados) {
                    for (let i in datos) {
                        fc_08_solicitudrenvacioncertificados.push(datos[i])
                    }
                }
            }
            if (res.data.data.fc_40_solicituddeadquisiciondehologramas) {
                for (let datos of res.data.data.fc_40_solicituddeadquisiciondehologramas) {
                    for (let i in datos) {
                        fc_40_solicituddeadquisiciondehologramas.push(datos[i])
                    }
                }
            }
            if (res.data.data.fc_34_notificacionsuspencionyreactivacion) {
                for (let datos of res.data.data.fc_34_notificacionsuspencionyreactivacion) {
                    for (let i in datos) {
                        fc_34_notificacionsuspencionyreactivacion.push(datos[i])
                    }
                }
            }
            if (res.data.data.fc_41_solicitudparabebidasconmezcal) {
                for (let datos of res.data.data.fc_41_solicitudparabebidasconmezcal) {
                    for (let i in datos) {
                        fc_41_solicitudparabebidasconmezcal.push(datos[i])
                    }
                }
            }
            if (res.data.data.fc_31_solicitudseguimiento) {
                for (let datos of res.data.data.fc_31_solicitudseguimiento) {
                    for (let i in datos) {
                        fc_31_solicitudseguimiento.push(datos[i])
                    }
                }
            }
            if (res.data.data.fc_36_solicituddeactualizacion) {
                for (let datos of res.data.data.fc_36_solicituddeactualizacion) {
                    for (let i in datos) {
                        fc_36_solicituddeactualizacion.push(datos[i])
                    }
                }
            }
            let solicitudes = []
            solicitudes.push({
                fc_01_solicitudderegistro: fc_01_solicitudderegistro,
                fc_05_solicitudusomarcaeimagen: fc_05_solicitudusomarcaeimagen,
                fc_06_registrodemaguey: fc_06_registrodemaguey,
                fc_08_solicitudrenvacioncertificados: fc_08_solicitudrenvacioncertificados,
                fc_09_solicitudemicioncertificadonomexportacionyentregahologram: fc_09_solicitudemicioncertificadonomexportacionyentregahologram,
                fc_30_notificaciontrasladodeproducto: fc_30_notificaciontrasladodeproducto,
                fc_31_solicitudseguimiento: fc_31_solicitudseguimiento,
                fc_33_solicitudenvasadonacional: fc_33_solicitudenvasadonacional,
                fc_34_notificacionsuspencionyreactivacion: fc_34_notificacionsuspencionyreactivacion,
                fc_35_notificaciondeserviciosvarios: fc_35_notificaciondeserviciosvarios,
                fc_36_solicituddeactualizacion: fc_36_solicituddeactualizacion,
                fc_40_solicituddeadquisiciondehologramas: fc_40_solicituddeadquisiciondehologramas,
                fc_41_solicitudparabebidasconmezcal: fc_41_solicitudparabebidasconmezcal,
            })
            return solicitudes?.[0]
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const metodosDireccionSlice = createSlice({

    name: 'metodosDireccionSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {
        [obtenerSolicitudesACDireccion.fulfilled]: (state, { payload }) => {
            state.estatusSolicitudesAC = payload
        },
    },

})


export const { } = metodosDireccionSlice.actions
export const DireccionGerenteReducer = metodosDireccionSlice.reducer